/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { createScreenPoint as e, createScreenPointArray as r } from "../../../core/screenUtils.js";
import { a as t } from "../../../chunks/vec2.js";
import { c as o } from "../../../chunks/vec3f64.js";
import n from "../../../geometry/Point.js";
import { getConvertedElevationFromVector as s } from "../../../support/elevationInfoUtils.js";

function c(e, r) {
  var t = e.x - r.x,
      o = e.y - r.y;
  return t * t + o * o;
}

function i(e, r) {
  var t = e.length === r.length && e[0] === r[0] && e[1] === r[1];

  switch (e.length) {
    case 2:
      return t;

    case 3:
      return t && e[2] === r[2];

    case 4:
      return t && e[3] === r[3];
  }

  return !1;
}

function a(r, t, o, n) {
  return "2d" === n.type ? n.toScreen(t.vectorToPoint(r, m)) : (f(r, t, o, n, u), n.state.camera.projectToScreen(u, d), e(d[0], d[1]));
}

function f(e, r, t, n) {
  var c = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : o();
  var i = r.toXYZ(e);
  return i[2] = s(n, i, r.spatialReference, t) || 0, n.renderCoordsHelper.toRenderCoords(i, r.spatialReference, c), c;
}

function l(e, r, t, o, n, c, i) {
  var a = t.toXYZ(e),
      f = t.toXYZ(r),
      l = s(n, a, t.spatialReference, o),
      p = s(n, f, t.spatialReference, o),
      u = (null == l ? p : null == p ? l : Math.min(l, p)) || 0;
  a[2] = u, f[2] = u, n.renderCoordsHelper.toRenderCoords(a, t.spatialReference, c), n.renderCoordsHelper.toRenderCoords(f, t.spatialReference, i);
}

function p(e, r) {
  r.sort(function (r, o) {
    return t(r.targetPoint, e) - t(o.targetPoint, e);
  });
}

var u = o(),
    d = r(),
    m = new n();
export { f as anyMapPointToRender, a as anyMapPointToScreenPoint, l as anyMapPointsToRenderWithEqualZ, i as objectEqual, p as sortCandidatesInPlace, c as squareDistance };